import BlindagemCard from "@/app/components/ServicesComponents/BlindagemCard";
import {
  CustomPaging,
  SampleNextArrow,
  SamplePrevArrow,
} from "@/app/components/swipersComponents";
import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { withServicesLayout } from "@/pages/_layoutService";
interface Benefit {
  icon: string;
  title: string;
  description: string;
}
function Blindagem() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentIndex(newIndex);
    },
    customPaging: (index: number) => {
      return (
        <CustomPaging
          key={"pagging-blindagem" + index}
          index={index}
          currentIndex={currentIndex}
        />
      );
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const benefits: Benefit[] = [
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/disponibilidade.png",
      title: "Disponibilidade",
      description:
        "Contratação do serviço de blindagem em concessionárias Toyota participantes espalhadas pelo Brasil para clientes que adquirirem um Corolla ou um Corolla Cross.",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/garantia.png",
      title: "Garantia",
      description:
        "Cinco anos de garantia de fábrica para o seu veículo. Cinco ou dez anos de garantia da blindagem, dependendo do material e vidro escolhido.",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/protecao.png",
      title: "Proteção",
      description:
        "Todos os materiais utilizados na blindagem, como o aço e a manta, estão de acordo com os padrões e pré-requisitos estabelecidos pela legislação brasileira.",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/qualidade.png",
      title: "Qualidade",
      description:
        "Processo de instalação seguindo os padrões Toyota de qualidade.",
    },
  ];
  return (
    <>
      <main className="flex flex-col max-w-[655px] mx-auto px-4 w-full">
        <header className="flex flex-col justify-center w-full text-4xl leading-10 text-black max-md:max-w-full">
          <div className="flex flex-col justify-center py-2 w-full max-md:max-w-full">
            <h1 className="max-md:max-w-full">
              Mais segurança para você e sua família
            </h1>
            <div className="flex mt-2.5 bg-red-600 rounded min-h-[2px] w-[60px]" />
          </div>
        </header>
        <section className="flex flex-col mt-4 w-full text-base leading-6 text-zinc-600 max-md:max-w-full">
          <p className="w-full max-md:max-w-full">
            Quem escolhe um Toyota busca um carro que oferece mais segurança e
            conforto para todos os passageiros. Ao optar pela blindagem
            certificada pela Toyota você terá contratado serviços que seguirão à
            risca o padrão de qualidade e atendimento que você já conhece.
          </p>
        </section>
        <section className="flex flex-col mt-4 w-full text-base leading-6 text-zinc-600 max-md:max-w-full">
          <p className="w-full max-md:max-w-full">
            As empresas certificadas passaram por uma primorosa e detalhada
            avaliação do processo de instalação da blindagem, oferecendo a você
            e sua família um serviço de confiança.
          </p>
        </section>
        <section className="flex flex-wrap gap-4 items-start py-4 mt-4 w-full text-zinc-600 max-md:max-w-full">
          <h2 className="flex flex-col grow shrink text-4xl leading-tight text-center w-[524px] max-md:max-w-full">
            Benefícios e vantagens
          </h2>
          <div className="flex flex-col w-full gap-5 max-lg:hidden">
            {benefits.map((benefit, index) => (
              <BlindagemCard key={"cardBlindagem" + index} {...benefit} />
            ))}
          </div>
          <div className="lg:hidden w-full mb-20">
            <Slider {...settings}>
              {benefits.map((benefit, index) => (
                <div key={`blindagem-mobile-${index}`} className="p-5">
                  <BlindagemCard
                    key={`blindagem-card-mobile-${benefit.title}-${index}`}
                    {...benefit}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </section>
        <section className="flex flex-col mt-4 w-full max-md:max-w-full">
          <div className="flex overflow-hidden gap-4 items-center px-4 pt-6 pb-4 w-full rounded-2xl shadow-[0px_0px_16px_rgba(0,0,0,0.17)] text-zinc-600 max-md:max-w-full">
            <div className="flex flex-col flex-1 shrink justify-center self-stretch my-auto w-full basis-0 min-w-[240px] max-md:max-w-full">
              <div className="flex flex-wrap gap-2.5 items-center w-full text-4xl leading-tight max-md:max-w-full">
                <img
                  loading="lazy"
                  src="https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/como_solicitar.png"
                  alt=""
                  className="object-contain shrink-0 self-stretch my-auto aspect-[2.35] w-[195px]"
                />
                <h2 className="self-stretch my-auto">Como solicitar?</h2>
              </div>
              <p className="mt-2 text-sm leading-5 max-md:max-w-full">
                Você pode solicitar a blindagem certificada na concessionária
                Toyota participante no momento da aquisição do seu veículo. O
                serviço será executado pela blindadora de sua preferência,
                certificada pela Toyota, e você retira seu veículo blindado
                diretamente na concessionária em que o adquiriu, com
                tranquilidade e segurança.
              </p>
            </div>
          </div>
        </section>
        <div className="flex flex-wrap gap-7 justify-between items-center p-4 w-full max-md:max-w-full">
          <img
            loading="lazy"
            src="https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/empresas_blindagem_01.png"
            alt="Company Logo 1"
            className="object-contain shrink-0 self-stretch my-auto aspect-[4.44] w-[111px]"
          />
          <div className="flex shrink-0 self-stretch my-auto w-px h-5 bg-zinc-700" />
          <img
            loading="lazy"
            src="https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/empresas_blindagem_02.png"
            alt="Company Logo 2"
            className="object-contain shrink-0 self-stretch my-auto aspect-[4.44] w-[111px]"
          />
          <div className="flex shrink-0 self-stretch my-auto w-px h-5 bg-zinc-700" />
          <img
            loading="lazy"
            src="https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/empresas_blindagem_03.png"
            alt="Company Logo 3"
            className="object-contain shrink-0 self-stretch my-auto aspect-[5.29] w-[111px]"
          />
          <div className="flex shrink-0 self-stretch my-auto w-px h-5 bg-zinc-700" />
          <img
            loading="lazy"
            src="https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/empresas_blindagem_04.png"
            alt="Company Logo 4"
            className="object-contain shrink-0 self-stretch my-auto aspect-[4.44] w-[111px]"
          />
        </div>
        <section className="flex flex-col my-4 w-full text-zinc-600 max-md:max-w-full">
          <div className="flex overflow-hidden gap-4 items-center px-4 pt-6 pb-4 w-full rounded-2xl shadow-[0px_0px_16px_rgba(0,0,0,0.17)] max-md:max-w-full">
            <div className="flex flex-col flex-1 shrink justify-center self-stretch my-auto w-full basis-0 min-w-[240px] max-md:max-w-full">
              <div className="flex flex-col w-full max-md:max-w-full">
                <div className="flex flex-wrap items-center w-full text-4xl leading-tight whitespace-nowrap max-md:max-w-full">
                  <h2 className="self-stretch my-auto">Modelos</h2>
                  <img
                    loading="lazy"
                    src="https://sablobsitestoyotaprd.blob.core.windows.net/images/Blindados/modelos_blindagem.png"
                    alt="Toyota Models"
                    className="object-contain flex-1 shrink gap-0 self-stretch my-auto aspect-[7.94] basis-0 min-w-[240px] w-[483px] max-md:max-w-full"
                  />
                </div>
                <p className="mt-2 text-sm leading-5 max-md:max-w-full">
                  A blindagem certificada pela Toyota está disponível para todas
                  as versões do Corolla (a partir do modelo 2020) e do Corolla
                  Cross, seja 0km ou seminovo. Os veículos seminovos precisam
                  passar por uma avaliação prévia em uma concessionária Toyota.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
export default withServicesLayout(Blindagem);
export { getServerSideProps } from "@/pages/_layoutService";
